import * as loom from '@loomhq/loom-embed';
export const loomParser = (url)=>loom.oembed(url);
